import React from "react";
import { Row, Col, Table, Button } from "reactstrap";
import Tenor from "../../../../assets/images/OCH/tenor.png";
import gameOverbg from "../../../../assets/images/OCH/gameOverbg.png";
import overgameimage from "../../../../assets/images/OCH/overgameimage.png";
import avatar from "../../../../assets/images/OCH/avatar.png";
import Cross from "../../../../assets/images/OCH/X.png";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../../socket/context";
import _ from "lodash";
import { removeUser } from "../../../../components/shared/utils";
// import FinalPlayers from "./finalPlayers";

const GameOverScreen = (props) => {
  const param = props.param;
  const roomData = _.get(props, "roomData");
  const users = _.get(roomData, "users") || [];
  const game_state = roomData ? _.get(roomData, "game_state") : null;

  // const game_state = {
  //   players: [
  //     { score: 12, player_hand: [], player_id: 1 },
  //     { score: 22, player_hand: [], player_id: 2 },
  //   ],
  // };
  // const users = [
  //   {
  //     active: true,
  //     audio_effect:
  //       "https://gameapart-config.s3.amazonaws.com/common/sfx/Cymbals.mp3",
  //     connected_on: "2021-02-27T04:47:36.996Z",
  //     connection_id: "bY1EQdR7IAMCJlg=",
  //     display_name: "Anthony Fauci",
  //     last_seen: "2021-02-27T04:47:36.996Z",
  //     player_id: 1,
  //     profile_image:
  //       "https://gameapart-assets.s3.amazonaws.com/photos%2F1595995629134_743E6F0C-2F66-4198-97C8-BC2BAEB3EA0D.jpg",
  //     user_id: "ae063d08-4e35-43d8-a462-b2b3280e966d",
  //   },
  //   {
  //     active: true,
  //     audio_effect:
  //       "https://gameapart-config.s3.amazonaws.com/common/sfx/Evil.mp3",
  //     connected_on: "2021-02-27T04:47:37.151Z",
  //     connection_id: "bY1EOfn2IAMCLpg=",
  //     display_name: "Rajat Sharma",
  //     last_seen: "2021-02-27T04:47:37.151Z",
  //     player_id: 2,
  //     profile_image:
  //       "https://gameapart-assets.s3.amazonaws.com/photos%2F1613731195749_5C86DA96-CDF6-45F8-9E1F-88B230DE8910.jpg",
  //     user_id: "99c10c57-ad00-4a00-95cd-498d7ce6825b",
  //   },
  // ];
  let winner = [];
  let losers = [];
  let max_total = [];
  let min_total = [];

  var max = -Infinity;
  var min = +Infinity;

  game_state.players.forEach(function (obj) {
    if (obj.total_score > max) {
      max = obj.total_score;
    }
    if (obj.total_score < min) {
      min = obj.total_score;
    }
  });
  const delPlayer = (data) => {
    // if (winner.length === 1 && losers.length === 0) {
    //   // const roomObj = roomData;
    //   // removeUser(roomObj, data);
    // } else if (winner.length === 0 && losers.length === 1) {
    //   // const roomObj = roomData;
    //   // removeUser(roomObj, data);
    // } else {
    const roomObj = roomData;
    removeUser(roomObj, data);
  };

  game_state.players.filter(function (el) {
    if (el.total_score === max) {
      max_total.push(el);
    } else {
      min_total.push(el);
    }
  });

  users.map((user) => {
    if (user?.player_id === max_total[0].player_id) {
      winner.push({ ...max_total[0], user });
    } else {
      min_total.map((min) => {
        if (min.player_id === user?.player_id) {
          if (min.total_score === undefined) {
            losers.push({ ...min, total_score: 0, user });
          } else {
            losers.push({ ...min, user });
          }
        }
      });
    }
  });
  console.log(winner, "winner==>");
  const sortPlayersHands = losers.sort(
    (a, b) => parseInt(b.total_score) - parseInt(a.total_score)
  );
  return (
    <div className="game-over-screen-wrapper">
      <h2 className="over-title">Game Over!</h2>
      <Row className="align-items-center">
        <Col md={5}>
          <div className="game-over-image text-center">
            <img src={overgameimage} className="img-fluid" />
          </div>
        </Col>
        <Col md={7}>
          {winner.length > 0 && (
            <div className="och-players-box m-0">
              <div className="och-player-image-wrapper">
                <img
                  // src={winner && winner[0].user && winner[0].user.profile_image}
                  src={
                    winner &&
                    winner[0]?.user &&
                    winner[0]?.user?.profile_image
                      .toString()
                      .includes("default-profile-icon")
                      ? avatar
                      : winner[0]?.user?.profile_image
                          .toString()
                          .includes("profileImage")
                      ? avatar
                      : winner[0]?.user?.profile_image
                          .toString()
                          .includes("profileImage")
                      ? avatar
                      : winner[0]?.user?.profile_image
                  }
                  className="och-player-image"
                />
                <Button
                  color="ochTheme"
                  className="cross-btn"
                  onClick={() => delPlayer(winner[0]?.user)}
                >
                  <img src={Cross} alt="cross" />
                </Button>
              </div>
              <div className="och-player-info">
                <h3>
                  {winner && winner[0]?.user && winner[0]?.user?.display_name}
                </h3>
                <p className="mb-0">
                  {param ? param.totalscore_text : "Total Score"}{" "}
                  <span>{winner && winner[0]?.total_score}</span>
                </p>
                <button className="winner-btn">
                  {param ? param.gamewinner_text : "GAME WINNER"}
                </button>
              </div>
            </div>
          )}
          <div className="och-winner-player-list">
            {sortPlayersHands &&
              sortPlayersHands.length &&
              sortPlayersHands.map((loser, index) => {
                return (
                  <div key={index} className="och-winner-player-box">
                    <div className="och-winner-image-wrap">
                      <img
                        // src={loser && loser.user && loser.user.profile_image}
                        src={
                          loser &&
                          loser.user &&
                          loser.user?.profile_image
                            .toString()
                            .includes("default-profile-icon")
                            ? avatar
                            : loser.user?.profile_image
                                .toString()
                                .includes("profileImage")
                            ? avatar
                            : loser.user?.profile_image
                        }
                        className="och-player-image"
                      />
                      <Button
                        color="ochTheme"
                        className="cross-btn"
                        onClick={() => delPlayer(loser.user)}
                      >
                        <img src={Cross} alt="cross" />
                      </Button>
                    </div>
                    <div className="result-total-score">
                      <h3>{loser && loser.user && loser.user?.display_name}</h3>
                      <p>{param ? param.totalscore_text : "Total Score"}</p>
                      <h2>
                        {loser && loser.total_score ? loser.total_score : "0"}
                      </h2>
                    </div>
                  </div>
                );
              })}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(GameOverScreen);

// export default GameOverScreen;
